<template lang="html">

  <section class="ficha-proyecto">

    <div class="wrapper margin-menu" v-if="!!data">

      <section class="intro column-center -agua-para-todos">
        <h2>Agua para todos</h2>
        <h1>{{data.name}}</h1>
      </section>

      <section class="breadcrumb">
        <nav class="container row-end">
          <router-link to="/">Inicio</router-link>
          <router-link :to="$t('enlaces.aguaparatodos')">Agua para todos</router-link>
          <router-link :to="$t('enlaces.proyectosencurso')">Proyectos en curso</router-link>
          <router-link :to="$t('enlaces.proyecto')+'/'+data.slug">{{data.name}}</router-link>
        </nav>
      </section>

      <main>


        <section class="container">

          <h2 class="title-intro row-center">
            <img src="/static/img/logo-agua-para-todos.png" alt="Logo agua para todos">
          </h2>

        </section>

        <section class="intro-proyecto-container column-start">
          <div class="intro-proyecto container row-start ais">

            <h2 class="big-title left -dark">{{data.country}} {{data.start_year}}</h2>

            <div class="imagen">
              <img :src="data.image" :alt="data.name">
            </div>

            <div class="contenedor-claim-donacion">
              <div class="claim-donacion">
                <h2>¿Nos ayudas?</h2>
                <div class="row-center">
                  <h3>Ya hemos conseguido un <strong>{{percent}}%</strong></h3>
                  <div class="imagenes row-center">
                    <gota :width="61" :height="90" :percent="percent"></gota>
                    <img src="/static/img/pozo-financiacion.svg" alt="Pozo">
                  </div>
                </div>
                <a @click="toPayment" class="btn skull-white" v-if="data.complete == 0">Quiero colaborar</a>
                <img src="/static/img/corazon.svg" alt="Corazón" class="corazon">
              </div>
            </div>

            <div class="texto">
              <h2 class="title-intro no-line">
                Sobre el <strong>Proyecto</strong>
              </h2>
              <p v-html="data.description"></p>
            </div>
          </div>

        </section>

        <section class="objetivos container row-between ais">
          <article>
            <h2 class="big-title">Objetivo</h2>
            <p>{{data.objective}}</p>
          </article>
          <article class="alcance">
            <h2 class="big-title">Alcance</h2>
            <p class="column-center"><strong class="personas">{{data.persons_helped}}</strong> Personas</p>
            <img src="/static/img/background-personas.svg" class="background-personas">
          </article>
          <article class="donde">
            <h2 class="big-title">Dónde</h2>
            <p>{{data.city}}, {{data.country}}</p>
          </article>
          <article class="ayuda">
            <h2 class="big-title">Ayuda</h2>
            <p>{{data.help}}</p>
            <img src="/static/img/manos-ayuda.svg" class="manos-ayuda">
          </article>
        </section>

        <section class="ficha-noticia container">

          <div class="container contenedor-noticia">

            <template v-for="el in data.body">

              <template v-if="!!el">

                <div v-if="el.tipo =='texto'" class="parrafo">
                  <p v-html="el.texto"></p>
                </div>

                <div class="contenedor-imagen" v-if="el.tipo == 'imagen'">

                  <img :src="el.enlace" v-if="el.tipo == 'imagen'" class="img-full">
                  <span v-html="el.pie" v-if="el.tipo == 'imagen'" class="pie"></span>

                </div>

                <h4 :nivel="el.nivel" v-if="el.tipo == 'destacado'" class="destacado-noticia" v-html="el.texto"></h4>

                <h2 v-if="el.tipo == 'titulo'" class="title--sup -green-line -black" v-html="el.value"></h2>

                <iframe :src="$options.filters.urlToID(el.enlace)" v-if="el.tipo == 'video'"></iframe>

                <div class="contenedor-link row-center" v-if="el.tipo == 'link'">

                  <div class="link row-start">
                    <a :href="el.enlace" class="enlace-cover" rel="noopener" target="_blank"></a>

                    <template v-if="!!el.meta.image">
                      <img v-if="!!el.meta.image.url" :src="el.meta.image.url" alt="imagen">
                    </template>

                    <h2>{{el.meta.title}}</h2>
                    <p>{{el.meta.description}}</p>
                  </div>

                </div>

                <div class="descargable row-center" v-if="el.tipo == 'file'">
                  <a :href="el.enlace" class="enlace-cover" rel="noopener" target="_blank"></a>
                  <span class="icon"></span>
                  <p v-if="!!el.meta.name">{{el.meta.name}}</p>
                </div>

                <ul v-if="el.tipo == 'lista' && el.estilo == 'unordered'">
                  <li v-for="el in el.objectos" v-html="el"></li>
                </ul>

                <ol v-if="el.tipo == 'lista' && el.estilo == 'ordered'">
                  <li v-for="el in el.objectos" v-html="el"></li>
                </ol>


              </template>

            </template>

          </div>

        </section>


        <div class="slider-wrapper" v-if="data.galery">
          <div class="big-title container left">Proyecto</div>
          <slide :gallery="data.galery" v-if="data.galery"></slide>
        </div>


        <section class="colabora-project">
          <div class="container colabora-title">
            <h2 class="big-title">Colabora</h2>
            <h3 class="title-intro no-line">¿Te animas a <strong>colaborar</strong>?</h3>

            <h3 class="title-intro small">
              Con tu donativo podremos seguir acercando el agua a <strong>aquellos que más lo necesitan</strong>
            </h3>
          </div>

          <div class="payment-container" v-if="data.complete == 0">
            <payment :id="data.id"></payment>
          </div>


        </section>


      </main>

    </div>

    <div class="loading-view column-center" v-else>
      <img src="/static/img/logo-fundacion-gris.svg" alt="imagen logo fundacion">
      <img src="/static/img/loading-red.svg" alt="imagen loading">
    </div>

  </section>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex'

  import payment from '@/components/parts/payment'

  import slide from '@/components/parts/slide';

  import gota from '@/components/parts/gota';


  export default {
    name: 'ficha-proyecto',
    created() {
      this.getProject();
    },
    data() {
      return {
        data: ''
      }
    },
    methods: {
      ...mapActions(['requestProject']),
      getProject() {
        this.requestProject(this.$route.params.id)
          .then((result) => {
            this.data = result.item;

            if (this.$route.hash.includes("#donar")) {
              setTimeout(e => {
                this.toPayment();
              }, 500)
            }

          })
      },
      toPayment() {
        $("html,body").animate({ scrollTop: $(".colabora-project").position().top - 150 }, '500');
      }
    },
    components: {
      'payment': payment,
      'slide': slide,
      'gota': gota
    },
    computed: {
      percent() {
        return (100 * this.data.total / this.data.money_needed).toFixed(2);
      }
    },
    watch: {
      '$route'() {
        this.getProject();
      }
    }
  }
</script>

<style scoped lang="scss">
  .ficha-noticia {}
</style>


// WEBPACK FOOTER //
// src/components/views/project-view.vue